import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useTranslation } from "react-i18next";
import { AssetKey } from "../../dto/AssetDTO";

/** Plural noun for the scoped type, e.g. "images". */
export const useScopeTypeName = () => {
  const { t } = useTranslation();
  return (type: AssetKey) =>
    t(`file_explorer_ui.scope_types.${AssetKey[type].toLowerCase()}`);
};

/**
 * Standing explanation of a type-scoped explorer, under the search row.
 *
 * The header pill says what the scope IS; this says what it MEANS — and
 * crucially why the other files are still on screen. Without it the dimming
 * has no stated cause and reads as a loading state.
 */
export default function AssetScopeNotice(props: { type: AssetKey }) {
  const { t } = useTranslation();
  const typeName = useScopeTypeName()(props.type);

  return (
    <div
      className="shrink-0 flex items-center gap-[8px] px-[16px] py-[9px] border-b border-creator-border bg-creator-primary-washed"
      data-testid="asset-scope-notice"
    >
      <InfoOutlinedIcon
        className="text-creator-text-key"
        sx={{ fontSize: 15 }}
      />
      <span className="text-[11.5px] leading-[17px] text-creator-text font-medium">
        {t("file_explorer_ui.scope_notice_title", { types: typeName })}
      </span>
      <span className="text-[11.5px] leading-[17px] text-creator-text-sub">
        {t("file_explorer_ui.scope_notice_body")}
      </span>
    </div>
  );
}
